import React, { InputHTMLAttributes } from 'react';

interface Props extends InputHTMLAttributes<HTMLInputElement> {}

export default function CustomInput({
    type,
    title,
    placeholder,
    onChange,
    required,
    pattern,
    maxLength,
    value,
    className = '',
    ...rest
}: Props) {
    const inputFieldStyle =
        'w-full rounded-[12px] border border-[#E8E0EC] bg-white px-4 py-3 text-[14px] text-[#334155] outline-none transition placeholder:text-[#94a3b8] focus:border-ryd-primary focus:ring-2 focus:ring-ryd-primary/15';

    return (
        <input
            type={type || 'text'}
            placeholder={placeholder}
            className={`${inputFieldStyle} ${className}`}
            onChange={onChange}
            pattern={pattern}
            title={title}
            required={required}
            maxLength={maxLength}
            value={value}
            {...rest}
        />
    );
}
